/**
 * Hamburger toggle for the navigation.
 */

const navigation = document.getElementById('site-navigation');
const toggleButton = document.getElementById('site-navigation-button');

const navigationActiveClassName = 'navigation--active';
const toggleButtonActiveClassName = 'hamburger--active';

const showNavigation = () => {
    navigation.classList.add(navigationActiveClassName);
    toggleButton.classList.add(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'true');
};

const hideNavigation = () => {
    navigation.classList.remove(navigationActiveClassName);
    toggleButton.classList.remove(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'false');
};

if (navigation && toggleButton) {
    toggleButton.addEventListener('click', () => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        isActive ? hideNavigation() : showNavigation();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            hideNavigation();
        }
    });
}

/**
 * Language switch redirect.
 */

const languageSwitch = document.querySelector('[data-language-switch]');
if (languageSwitch) {
    languageSwitch.addEventListener('change', () => {
        window.location.href = languageSwitch.value;
    });
}

/**
 * Opening and closing for menu flyouts.
 */

/**
 * Close all flyouts on the page.
 */
const closeAllFlyouts = () => {
    document.querySelectorAll('[data-flyout-parent]').forEach(item => {
        item.removeAttribute('data-flyout-active');
    });
};

/**
 * Open or close a flyout for the given menu item.
 * @param {Element} item
 */
const toggleFlyout = item => {
    const isActive = item.dataset.flyoutActive !== undefined;

    // Allow only one open flyout in the desktop navigation
    const isMobileLayout = toggleButton ? Boolean(toggleButton.offsetParent) : false;
    if (!isMobileLayout) {
        closeAllFlyouts();
    }

    if (isActive) {
        item.removeAttribute('data-flyout-active');
    } else {
        item.setAttribute('data-flyout-active', '');
    }
};

document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
        closeAllFlyouts();
        return;
    }

    if (['Enter', ' '].includes(e.key)) {
        if (!e.target.closest('[data-flyout-link]')) {
            return;
        }

        e.preventDefault();
        toggleFlyout(e.target.closest('[data-flyout-parent]'));
    }
});

document.addEventListener('click', e => {
    if (!e.target.closest('[data-flyout-parent]')) {
        closeAllFlyouts();
        return;
    }

    if (!e.target.closest('[data-flyout-link]')) {
        return;
    }

    e.preventDefault();
    toggleFlyout(e.target.closest('[data-flyout-parent]'));
});
